import React from 'react';
import PropTypes from 'prop-types';

const AbilityDisplayName = ({ ability: { displayName }, abilityActivated }) => (
  <>
    <span style={{ color: abilityActivated ? '#34a835' : '#e91224' }}>
      <i className="pi pi-star" />
      {displayName}
    </span>
  </>
);

AbilityDisplayName.propTypes = {
  abilityActivated: PropTypes.bool.isRequired,
  displayName: PropTypes.string.isRequired,
  ability: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AbilityDisplayName;
